import _ from 'lodash'
import classNames from 'classnames'
import React, { PureComponent } from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import EngineUIRooms from '../../../components/atoms/EngineUI/Rooms'

import engine from '../../../actions/engine'

class Rooms extends PureComponent {
  render () {
    // return a boolean if there is a value in the childAges array that matches 1 (infant exists in party)
    const hasInfant = !!this.props.childAges.find(age => age.value === 1)
    const pleaseNote = <FormattedMessage id='common.pleaseNote' tagName='strong' />

    return (
      <div className={classNames({
        'searchform-roomtype': true,
        'has-error': this.props.error
      })}>
        <div className='form-group'>
          <EngineUIRooms
            label={this.props.label}
            id='rooms_select'
            rooms={this.props.rooms}
            suggestions={this.props.roomTypes}
            onChange={this.props.change}
          />
          {this.props.error && <div className='help-block'>{this.props.error}</div>}
        </div>
        {hasInfant && !this.props.visiblePartyComp &&
          <div className='alert alert-info mb-0' role='alert'>
            <FormattedMessage id='common.infantsUnder1NotIncluded' tagName='p' values={{ pleaseNote }} />
          </div>
        }
      </div>
    )
  }
}

function mapStateToProps (state) {
  const {
    childAges,
    rooms,
    roomTypes
  } = state.engine.engineStore

  const {
    errorRooms,
    visiblePartyComp
  } = state.engine

  return {
    childAges,
    rooms,
    roomTypes,
    visiblePartyComp,
    error: errorRooms,
    label: _.get(state.engine.brandConfig, 'UITextDefaults.labelRooms', 'Room')
  }
}

function mapDispatchToProps (dispatch) {
  return {
    change: (roomNumber, roomCode) => {
      return dispatch(engine.changeRoom(roomNumber, roomCode))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Rooms)
